import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Country } from 'src/app/models/country.model';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private defaultUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) {
  }
  getcountrylist() {  
    return this.http.get(`${this.defaultUrl}Region/GetAllCountries`);
  }

  getCountry() {
    return this.http.get<any>('assets/countryhelp.json')
      .toPromise()
      .then(res => <Country[]>res.data)
      .then(data => { return data; });
    }
}
